import StandalonePrintProductConfigurator from './views/StandalonePrintProductConfigurator';
import RequireRole from '../../components/routing/RequireRole';
import ACCOUNT_ROLES from '../../constants/account-roles';
import AdminPurchasedCustomPrintConfigurator from './views/AdminPurchasedCustomPrintConfigurator';

const RequireAdminRole = RequireRole([ACCOUNT_ROLES.ADMINISTRATOR]);

const printServiceRoutes = [
  {
    path: '/print-products/:printProductId',
    exact: true,
    component: StandalonePrintProductConfigurator,
  },
  {
    path: '/prints/config/:purchasedCustomPrintId',
    exact: true,
    component: RequireAdminRole(AdminPurchasedCustomPrintConfigurator),
  },
];

export default printServiceRoutes;
